import { BiSolidBellRing } from 'react-icons/bi';
import { alarmOptions } from '../../../config/audio/alarms';
import { useAudio } from '../../../hooks/useAudio';
import { useSettingsStore } from '../../../store/settingsStore';
import { useThemeStore } from '../../../store/themeStore';
import { KID_SOUNDS, playKidSound } from '../../../utils/kidSounds';
import Dropdown from '../../common/Dropdown';
import ListItem from '../../common/ListItem';

const AlarmSelector: React.FC = () => {
    const { selectedTheme } = useThemeStore();
    const { selectedAlarm, setSelectedAlarm } = useSettingsStore();
    const audio = useAudio();

    const alarmIcon = <BiSolidBellRing size={24} className="size-full" />;

    const handleAlarmChange = (alarm: typeof selectedAlarm) => {
        setSelectedAlarm(alarm);
        if (alarm.startsWith('kid:')) {
            playKidSound(alarm.slice(4));
        } else {
            setTimeout(() => {
                audio.play(alarm);
            }, 0);
        }
    };

    const handleDropdownToggle = (isOpen: boolean) => {
        if (!isOpen) {
            audio.pause();
            audio.reset();
        }
    };

    // Build options: bundled alarms + kid sounds
    const kidSoundOptions = KID_SOUNDS.map((s) => ({
        label: `${s.emoji} ${s.label}`,
        value: `kid:${s.id}`,
    }));
    const allOptions = [...alarmOptions, ...kidSoundOptions];

    const alarmSelector = (
        <div className="flex w-full flex-col gap-2">
            <div className="text-lg">Sound</div>
            <Dropdown
                options={allOptions}
                selectedValue={selectedAlarm}
                onChange={handleAlarmChange}
                currentTheme={selectedTheme}
                buttonBorderColor={selectedTheme.color.point}
                onToggle={handleDropdownToggle}
            />
            <div className="mt-2 flex flex-wrap gap-2">
                <span className="w-full text-xs opacity-60">Quick kid sounds:</span>
                {KID_SOUNDS.map((s) => (
                    <button
                        key={s.id}
                        type="button"
                        onClick={() => playKidSound(s.id)}
                        title={s.label}
                        className="flex size-10 items-center justify-center rounded-full text-xl transition-all hover:scale-110"
                        style={{ backgroundColor: `${selectedTheme.color.point}22` }}
                    >
                        {s.emoji}
                    </button>
                ))}
            </div>
        </div>
    );

    return <ListItem icon={alarmIcon} content={alarmSelector} />;
};

export default AlarmSelector;
